import styled from 'styled-components';
import { IconCrown, IconTrash } from '../../../../components/icons';
import { DescriptionText } from '../styles';

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 0px 17px;
  border-radius: 9px;
  margin-bottom: 40px;
  cursor: pointer;
  transition: transform 350ms ease;
  transform: translateY(0px);

  @media only screen and (min-width: 1024px) {
    &:hover {
      transform: translateY(-3px);
    }
  }
`;

export const ClickArea = styled.a`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 90%;
  padding: 28px 0;
`;

export const PhotoArea = styled.div`
  position: relative;
`;

export const Photo = styled.img`
  width: 52px;
  height: 52px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 10px;
`;

export const DeleteButton = styled.button`
  display: block;
`;

export const Text = styled(DescriptionText)``;


// Icons
export const TrashIcon = styled(IconTrash).attrs({
    width: 20,
    height: 24,
  })`
    fill: none;
  
    transform: scale(1);
    transition: transform 350ms ease;
    @media only screen and (min-width: 1024px) {
      &:hover {
        transform: scale(1.15);
      }
    }
`;

export const CrownIcon = styled(IconCrown).attrs({
  width: 20,
  height: 24,
})`
  position: absolute;
  top: -5px;
  right: 5px;
`;